import { storageData } from "services/Services"

const AntiTheftSystemList = () => {
    let options = []
    try {
        const dropdownOptions = JSON.parse(storageData.getItem('DropdownOptions'))
        const antiTheftSystemOptions = dropdownOptions.rows.filter(row => row.QuestionID === "141")

        if (antiTheftSystemOptions.length > 0) {
            options = [
                <option key="default" disabled value="">Select from the following...</option>,
                ...antiTheftSystemOptions.map(answer => (
                    <option key={answer.AnswerID} value={answer.AnswerText}>{answer.AnswerText}</option>
                ))
            ]
        }
    } catch (error) {
        console.error(error)
        options = [<option key="default" value="">Select from the following...</option>]
    }

    return <>{options}</>
}

export default AntiTheftSystemList